import React, { Component, Fragment } from 'react'
import { Form, Input, Button, Modal, Radio, message } from 'antd'
import GoodsSpecsTable from './GoodsSpecsTable'
import { getStatusName } from '../tableconfig/goodTable'

import { setGoodsCommission, submitExamine } from '_src/api/api'

import './style/GoodsExamineModel.less'
@Form.create({name: 'GoodsSpecsModel'})
class GoodsExamineModel extends Component {
  constructor (props) {
    super(props)
    this.showExamineModel = this.showExamineModel.bind(this)
    this.valueParms = [] // 商品价格
    this.goodsId = ''
    this.statusValue = ''
    this.state = {
      visible: false,
      status: null, // 审批状态
      message: '', // 留言
      stateGoodsSn: '',
      model: '',
      GoodsSpecsParam: {
        goodSpecifications: []
      },
    }
  }

  // 显示审批对话框
  showExamineModel (record, model = 'edite') {
    const { id, status, message } = record
    this.goodsId = id
    // 转态准换
    if (status === 0) {
      this.statusValue = 1
    }
    if (status === -1) {
      this.statusValue = 0
    }
    
    this.setState(()=>({
      visible: true,
      model,
      status,
      message: message,
      GoodsSpecsParam: {goodSpecifications: record.goodSpecifications || []}
    }), ()=>{
      this.props.form.setFieldsValue({
        status: this.statusValue,
        message,
      })
    })
  }
  // 隐藏对话框
  handleCancel = () =>{
    this.setState({
      visible: false
    })
  }

  // 佣金提交
  onGoodsCommission = () => {
    const load = message.loading('审核提交中...', 0)
    const param = Object.values(this.valueParms)
    
    setGoodsCommission(this.goodsId, {goodsSpecificationSetFroms: param})
      .then(res => {
        const { subscribeLoad } = this.props
        subscribeLoad(load)
        this.handleCancel()
      })
  }

  
  getValues = (params) => {
    this.valueParms = {...params}
  }

  // 商品审核
  onSubmitExamine = (e) => {
    const { model } = this.state
    if (model === 'watch') {
      this.handleCancel()
    }
    else {
      e.preventDefault()
      this.props.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          const param = values
          submitExamine(this.goodsId, param)
            .then(res=>{
              this.onGoodsCommission()
            })
        }
      })
    }
  }
  render () {
    const { visible, GoodsSpecsParam, model, status } = this.state
    const { getFieldDecorator } = this.props.form
    const EditeNode = (
      <Form labelCol = {{span: 4}} wrapperCol = {{span: 14}}>
              
        <Form.Item label="商品状态" >
          {
            getFieldDecorator('status', {
              rules: [{ required: true, message: '商品状态不能为空' }],
              initialValue: 1
            })(
              <Radio.Group onChange={this.handleFormLayoutChange}>
                <Radio value={1}>通过</Radio>
                <Radio value={0}>不通过</Radio>
              </Radio.Group>
            )
          }
                
        </Form.Item>
        <Form.Item label="留言" >
          {
            getFieldDecorator('message', {
              rules: [{ required: true, message: '留言不能为空' }],
              initialValue: ''
            })(
              <Input.TextArea placeholder="请输入您的留言" autosize = {{minRows: 4, maxRows: 8}} maxLength = "200" />
            )
          }
        </Form.Item>
      </Form>
    )
    
    const dec = this.state.message || '无'
    const WatchNode = (
      <div className = "GoodsExamineModel_watch">
        <div className = "list"><p className = "title">商品状态：</p><p style = {{color: getStatusName(status).color}}>{getStatusName(status).text}</p></div>
        <div className = "list"><p className = "title">留言：</p><p>{dec}</p></div>
      </div>
    )
    return (
      <Modal
        visible={visible}
        confirmLoading={false}
        destroyOnClose
        onCancel={this.handleCancel}
        footer = {(
          <Fragment>
            <Button onClick = {this.handleCancel}>点击关闭</Button>
            {model === 'watch'?null
              :<Button onClick = {this.onSubmitExamine} type = "primary">确定审核</Button>
            }
            
          </Fragment>
        )}
        width = "700px"
      >
        <div >
          <div className = "examine_session">
            <h3 className = "session_title">商品审核</h3>
            {model === 'watch' ? WatchNode:EditeNode}
          </div>
          <div className = "examine_session">
            <h3 className = "session_title">设置佣金</h3>
          </div>
          <GoodsSpecsTable param = {GoodsSpecsParam} model = {model} onInputs = {this.getValues} />
        </div>
        {/* <Button onClick = {this.Test} >测试按钮</Button>
        <Button onClick = {this.TextExamine} >测试审核</Button> */}
      </Modal>
    )
  }

  
}

export default GoodsExamineModel